import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { EngagementModel } from '../models/engagement.model';
import { PreviewAttributeModel } from '../models/PreviewAttribute.model';
import { PreviewAttributeArrayModel } from '../models/previewAttributesArary.model';
import { UserModel } from '../models/user.model';
import { SourceFile } from '../models/sourceFile.model';
import { SourceFileTab } from '../models/SourceFileTab';
import { ScenarioResult } from '../models/scenarioResult.model';
import { EntityModel } from '../models/legalentity-model';
import { tap } from 'rxjs/operators';
import { InfraService } from './infra.service';
import { InfraEndPointModel } from '../models/infraEndPoint.model';

@Injectable({
  providedIn: 'root'
})
export class DatabookcompareService {
 private configCoreCompareDatabookUrl: string;
  private infraDetails: InfraEndPointModel;
  private logOutCoreUrl: string;

constructor(private infraService: InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe((data: InfraEndPointModel) => {
      this.infraDetails = data;
      this.configCoreCompareDatabookUrl = data.WebEndPoint2 + 'CompareDatabook';
      this.logOutCoreUrl = data.WebEndPoint2 + 'LogOut';

    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

}
  public getCompareDatabookData(file1: string) {
    return this.http.get(`${this.configCoreCompareDatabookUrl}/getCompareDatabookData/${file1}`);
  }
}
